import classNames from 'classnames'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { IPartnerGroupAdditionalInfo } from '../../../models/IPartnerGroupAdditionalInfo'
import { StyledInputs } from '../../styledComponents/styledInput/StyledInputs'

import styles from './MainInfo.module.scss'

interface IProps {
  partnerGroupInfo: IPartnerGroupAdditionalInfo
  partnerData: IWWPartners | null
  dataEntryId: number
}

export const AccountIds = ({ partnerGroupInfo, partnerData, dataEntryId }: IProps) => {
  return (
    <div className={styles.root}>
      <StyledInputs label={getFormedEltTranslation('meet-account-id')}>
        <p className={styles.accountIds}>
          <div className={styles.block}>
            <div className={styles.blockFirst}>
              <RenderWhen condition={partnerGroupInfo.membersCount !== 0}>
                <div className={styles.item}>
                  <div className={styles.itemFirst}>
                    <Translation text={getFormedEltTranslation('meet-account-members')} />
                  </div>
                  <div className={styles.itemLast}>{partnerGroupInfo.membersCount}</div>
                </div>
              </RenderWhen>
              <RenderWhen condition={partnerGroupInfo.membersCount == 0}>
                <div className={styles.itemOnly}>
                  {partnerData?.PartnerID} / {partnerData?.LocationID}
                </div>
              </RenderWhen>
            </div>
          </div>
          <div>
            <div className={styles.item}>
              <RenderWhen condition={!!partnerGroupInfo.groupId}>
                <div className={styles.itemFirst}>
                  <Translation
                    text={getFormedEltTranslation('add-new-partner-to-group-main-partner')}
                  />
                </div>
              </RenderWhen>
              <RenderWhen condition={!!partnerGroupInfo.groupId}>
                <div className={styles.itemLast}>
                  <span>{partnerGroupInfo.mainHqPartnerName}</span>
                  <span>
                    {'<'}
                    {partnerGroupInfo.mainHqPartnerId} / {partnerGroupInfo.locationId}
                    {'>'}
                  </span>
                </div>
              </RenderWhen>
              <RenderWhen
                condition={!partnerGroupInfo.mainHqPartnerName && !!partnerGroupInfo.groupId}
              >
                <div className={styles.itemLast}>
                  <Tooltip
                    tipContent={() => (
                      <Translation
                        text={getFormedEltTranslation('manage-partner-group-no-main-partner')}
                      />
                    )}
                    inline
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className={classNames('kbase kbase-warning', styles.warningIcon)}
                    />
                  </Tooltip>
                </div>
              </RenderWhen>
            </div>
          </div>
        </p>
      </StyledInputs>
    </div>
  )
}
